import cssPrepareData from './../../../components/Layout/cssPrepare';
import APP from 'app';

const getThemeConfigData = () => {
    const { themeData = {} } = APP.Utils.fetchInfoData();
    return cssPrepareData(themeData);
};

export default getThemeConfigData;
